import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './DeleteAccount.css';
import React, { useState } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, canUseDOM, getColorByTheme, getPageThemeColors } from '../../utils';
import { loaderToggle, getLatestUserCookie, logoutUser } from './user_session';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import Modal from '../atoms/Modal/Modal';
import { useModal } from '../atoms/Modal/useModal';
import SelectFieldCustom from './components/SelectFieldCustom';
var DeleteAccount = function DeleteAccount(_ref) {
  var params = _ref.params,
    fields = _ref.fields;
  var loggedOut = 'LoggedOut';
  var generalErrorCode = 'Failed';
  var formPostErrors = [];
  var allErrors = [];
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var clientId = get(sitecoreContext, 'configuration.globalApi.clientId') || 'replaceint2';
  var currentLang = get(sitecoreContext, 'language');
  var _useModal = useModal(),
    isShown = _useModal.isShown,
    toggle = _useModal.toggle;
  var identityGlobal = get(sitecoreContext, 'configuration.globalApi.identityGlobal') || 'https://replaceidentityGlobal';
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    disableSubmit = _useState2[0],
    setDisableSubmit = _useState2[1];
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    deleteReason = _React$useState2[0],
    setDeleteReason = _React$useState2[1];
  var _useState3 = useState([{
      text: '',
      value: ''
    }]),
    _useState4 = _slicedToArray(_useState3, 2),
    reasonsForRendering = _useState4[0],
    setReasonsForRendering = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formResponseError = _useState6[0],
    setFormResponseError = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    formSuccess = _useState8[0],
    setFormSuccess = _useState8[1];
  var reasons = get(fields, 'data.datasource.reasons') || [];
  var dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  var _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isVdsite = _React$useState4[0],
    setIsVdsite = _React$useState4[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var selectedPrimaryActiveColor = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  var variables = BackgroundColorHex ? {
    '--delete-profile-background-color': BackgroundColorHex,
    '--delete-profile-background-active-color': ActiveColorHex,
    '--delete-profile-color': ColorHex
  } : {
    '--delete-profile-background-color': selectedPrimaryColor,
    '--delete-profile-background-active-color': selectedPrimaryActiveColor,
    '--delete-profile-color': getColorByTheme(selectedPrimaryColor)
  };
  var mapDictionary = dictionaryValues.reduce(function (map, currentValue) {
    return map.set(currentValue.key.jss.value, currentValue.phrase.jss.value);
  }, new Map());
  formPostErrors.push({
    errorCode: generalErrorCode,
    message: mapDictionary.get('changePasswordApiError') || ''
  });
  formPostErrors.push({
    errorCode: loggedOut,
    message: mapDictionary.get('user not logged in error message') || ''
  });
  var deleteAccountText = mapDictionary.get('deleteAccount');
  var deleteInfoText = mapDictionary.get('deleteInfo');
  var proceedText = mapDictionary.get('proceed');
  var cancelText = mapDictionary.get('cancel');
  var deleteInfoPopupText = mapDictionary.get('deleteInfoPopup');
  var deleteYourAccountText = mapDictionary.get('deleteYourAccount');
  var whyDeleteQuestionText = mapDictionary.get('whyDeleteQuestion');
  var placeholder = mapDictionary.get('pleaseSelect');
  var recaptchErrorMessage = mapDictionary.get('errorRecaptchaRequired');
  React.useEffect(function () {
    var arr = [];
    reasons.forEach(function (item) {
      arr.push({
        value: get(item, 'reason.jss.value'),
        label: get(item, 'reason.jss.value')
      });
    });
    setReasonsForRendering(arr);
  }, []);
  var handleCancelClick = function handleCancelClick() {
    toggle();
    setFormResponseError('');
  };
  var handleButtonClick = function handleButtonClick() {
    toggle();
  };

  // Show Form Response Errors
  var showResponseError = function showResponseError(errorCode) {
    var errorObject = formPostErrors.find(function (errorItem) {
      return errorItem.errorCode === errorCode;
    });
    if (errorObject) {
      setFormResponseError(errorObject.message);
    } else {
      setFormResponseError(formPostErrors[0].message);
    }
  };
  var handleDelete = function handleDelete(authToken) {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', "Bearer ".concat(authToken));
    var raw = "{\n\t\t\t\"Lang\" : \"".concat(currentLang, "\",  \n\t\t\t\"ClientId\" : \"").concat(clientId, "\",  \n\t\t\t\"Reason\" : \"").concat(deleteReason, "\"\n\t\t}");
    var requestOptions = {
      method: 'POST',
      body: raw,
      headers: myHeaders,
      redirect: 'follow'
    };
    var statusCode = 0;
    fetch("".concat(identityGlobal, "/api/user/Delete"), requestOptions).then(function (response) {
      loaderToggle(false, setDisableSubmit);
      statusCode = response.status;
      return response.text();
    }).then(function (result) {
      var responseObj;
      if (result) {
        responseObj = JSON.parse(result);
      }
      if (statusCode === 200) {
        if (responseObj.isSuccess) {
          setFormSuccess(true);
        } else if (!responseObj.isSuccess) {
          if (responseObj.errors && responseObj.errors.length) {
            throw Error(responseObj.errors[0].code);
          }
        }
        logoutUser().then(function (response) {
          if (response) {
            window.location.href = '/';
          }
        });
      } else {
        throw Error(generalErrorCode);
      }
    }).catch(function (error) {
      console.log('error', error);
      loaderToggle(false, setDisableSubmit);
      if (statusCode === 0) {
        showResponseError(generalErrorCode);
      } else {
        showResponseError(error.message);
      }
    });
  };

  // Validate all fields on submit
  var validateAllFields = function validateAllFields() {
    var success = true;
    return success;
  };
  var formSubmit = function formSubmit(event) {
    event.preventDefault();
    setFormResponseError('');
    if (validateAllFields()) {
      loaderToggle(true, setDisableSubmit);
      getLatestUserCookie().then(function (response) {
        if (response.login_status) {
          if (response.error) {
            loaderToggle(false, setDisableSubmit);
            showResponseError(generalErrorCode);
          } else {
            handleDelete(response.access_token);
          }
        } else {
          loaderToggle(false, setDisableSubmit);
          showResponseError(loggedOut);
        }
      });
    }
  };
  var reasonsFieldProps = {
    value: deleteReason ? {
      value: deleteReason,
      label: deleteReason
    } : null,
    label: '',
    id: 'delete-reason',
    name: 'delete-reason',
    labelLight: false,
    autoComplete: 'delete-reason',
    required: false,
    changeEvent: function changeEvent(value) {
      setDeleteReason(value);
    },
    blurEvent: function blurEvent(value) {},
    options: reasonsForRendering,
    placeholder: placeholder
  };
  allErrors.push(reasonsFieldProps);
  if (!fields) {
    console.warn('Delete account component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "['Delete account is empty: please provide datasource]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "delete-acc col-xl-8 offset-xl-1",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "delete-acc__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "delete-acc__header"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C_186",
    "data-name": "\u0421\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C 186",
    transform: "translate(-376 -747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u042D\u043B\u043B\u0438\u043F\u0441_80",
    "data-name": "\u042D\u043B\u043B\u0438\u043F\u0441 80",
    transform: "translate(376 747)",
    fill: "none",
    stroke: "var(--delete-profile-background-color)",
    "stroke-width": "2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "10",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "9",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C_157",
    "data-name": "\u0421\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C 157",
    transform: "translate(1879.223 -9641.982) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C_145",
    "data-name": "\u0421\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C 145",
    transform: "translate(1492.199 -10404.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\u041A\u043E\u043D\u0442\u0443\u0440_129",
    "data-name": "\u041A\u043E\u043D\u0442\u0443\u0440 129",
    d: "M6.5,9.677a.912.912,0,0,1-.913-.913V4.738a.913.913,0,1,1,1.826,0V8.764A.912.912,0,0,1,6.5,9.677Z",
    transform: "translate(-5.585 -3.825)",
    fill: "var(--delete-profile-background-color)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C_146",
    "data-name": "\u0421\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C 146",
    transform: "translate(1492.016 -10396.144)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\u042D\u043B\u043B\u0438\u043F\u0441_79",
    "data-name": "\u042D\u043B\u043B\u0438\u043F\u0441 79",
    cx: "1.095",
    cy: "1.095",
    r: "1.095",
    fill: "var(--delete-profile-background-color)"
  }))))), /*#__PURE__*/React.createElement("span", {
    className: "delete-acc__title"
  }, deleteAccountText)), /*#__PURE__*/React.createElement("p", {
    className: "delete-acc__notification"
  }, deleteInfoText)), /*#__PURE__*/React.createElement("div", {
    className: "delete-acc__cta"
  }, proceedText && /*#__PURE__*/React.createElement("button", {
    className: "btn btn-secondary delete-acc__btn",
    onClick: handleButtonClick,
    "data-cy": "proceed",
    tabIndex: 0
  }, proceedText))), /*#__PURE__*/React.createElement(Modal, {
    isShown: isShown,
    hide: handleCancelClick,
    style: {
      maxWidth: '520px'
    },
    primaryColor: selectedPrimaryColor,
    primaryActiveColor: selectedPrimaryActiveColor
  }, /*#__PURE__*/React.createElement("div", {
    className: "delete-account-modal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "delete-account-modal__header"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "h3"
  }, deleteYourAccountText), /*#__PURE__*/React.createElement("span", {
    className: "delete-account-modal__text"
  }, deleteInfoPopupText)), /*#__PURE__*/React.createElement("div", {
    className: "delete-account-modal__content"
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: function onSubmit(event) {
      return formSubmit(event);
    },
    noValidate: true
  }, /*#__PURE__*/React.createElement("legend", {
    className: "accessibility-hidden-text"
  }, whyDeleteQuestionText), /*#__PURE__*/React.createElement("label", {
    className: "body-small wiz__label",
    htmlFor: "delete-account-reason"
  }, whyDeleteQuestionText), /*#__PURE__*/React.createElement(SelectFieldCustom, reasonsFieldProps), formResponseError && formResponseError.length ? /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-error-response"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lr__error"
  }, formResponseError)))) : null, /*#__PURE__*/React.createElement("div", {
    className: "delete-account-modal__footer"
  }, /*#__PURE__*/React.createElement("button", {
    disabled: disableSubmit,
    className: "btn btn-primary delete-account-modal__btn-delete",
    type: "submit"
  }, deleteAccountText), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-secondary delete-account-modal__btn-cancel",
    onClick: handleCancelClick
  }, cancelText))))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: "".concat(rtl ? rtlStyles : ltrStyles, " ").concat(commonStyles)
  }, children);
};
var commonStyles = "cyslhjd";
var ltrStyles = "l1hqfdng";
var rtlStyles = "rz9gfvw";
export default DeleteAccount;